<div class="app_printFooter__container print_dont_break">
  <div class="p-grid">
    <div class="p-col-6 p-md-6">
      <ng-container *ngIf="firmaB64">
        <img [src]="firmaTrabajador" alt="Firma del trabajador">
      </ng-container>
    </div>
    <div class="p-col-6 p-md-6">
      <ng-container *ngIf="medicoFirmaB64">
        <img [src]="firmaMedico" alt="Firma del médico">
      </ng-container>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-6 p-md-6">
      <p class="firma"><app-fiel-title label="Firma y aclaración del trabajador"></app-fiel-title></p>
      <span class="trabajador">{{trabajadorApellidoNombre}}</span>
    </div>
    <div class="p-col-6 p-md-6">
      <p class="firma"><app-fiel-title label="Firma y sello del médico"></app-fiel-title></p>
      <span class="nombre">{{medicoNombre}}</span>
      <span class="especialidad">{{especialidad}}</span>
      <span class="matricula" *ngIf="medicoMatricula">Matrícula: {{medicoMatricula}}</span>
    </div>
  </div>
</div>
